import { render, staticRenderFns } from "./HolidayCard.vue?vue&type=template&id=5792b3f9"
import script from "./HolidayCard.vue?vue&type=script&lang=js"
export * from "./HolidayCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports